import React from "react";

const CustomProgressBar = ({
  progress,
  height = "20px",
  fillColor = "#004992",
  backgroundColor = "#BFDFFF",
  borderRadius = "20px",
  className = "",
  style = {},
}) => {
  return (
    <div
      className={className}
      style={{
        height,
        borderRadius,
        backgroundColor,
        overflow: "hidden",
        ...style,
      }}
      >
      <div
        style={{
          width: `${progress}%`,
          borderRadius,
          height: "100%",
          backgroundColor: fillColor,
        }}
      ></div>
    </div>
  );
};

export default CustomProgressBar;
